module.exports = __webpack_public_path__ + "static/media/dog-breed.47495d6e.png";